

























import { Vue, Component, Prop } from 'vue-property-decorator'
import { PdState, PdGroupList } from '@/store/pd/types'
import { PdQualityPropertyNames, PdHasImagePropertyNames } from '@/types/pd'
import { capitalize } from '@/utils/string'
import {
  WasteFluidDict,
  ExitsiteDict,
  SwellingDict,
  WasteFluidTypes,
  ExitsiteTypes,
  SwellingTypes
} from '@/constants/pd'
import {
  QualitySettingNames,
  PdSettingPropTypes,
  PdSettingCollections,
  FormattedPdSetting
} from '@/store/pdSetting/types'
import { ExStore } from 'vuex'

@Component
export default class PdTabIndex extends Vue {
  @Prop({ type: Object, required: true }) pdGroups!: PdGroupList
  @Prop({ type: Array, required: true }) datetimeSort!: Array<string>
  @Prop({ type: String, required: true }) type!: PdQualityPropertyNames
  @Prop({ type: String, required: true }) title!: PdQualityPropertyNames

  readonly pdSettingTypes: Array<PdSettingPropTypes> = ['emg', 'warn']

  $store!: ExStore

  get formattedPdSetting() {
    return this.$store.getters['pdSetting/format']
  }

  capitalize(str: string) {
    return capitalize(str)
  }

  getQualityItemText(pd: Array<PdState>, name: PdQualityPropertyNames) {
    if (pd.length > 1) {
      return '複数項目'
    }

    if (pd[0][name] === null) {
      return ''
    }

    const getName = (name: string, index: number) => {
      switch (name) {
        case 'wasteFluid':
          return WasteFluidDict[index as WasteFluidTypes]
        case 'exitsite':
          return ExitsiteDict[index as ExitsiteTypes]
        case 'swelling':
          return SwellingDict[index as SwellingTypes]
        default:
          throw new Error(`property name of ${name} is not supported`)
      }
    }

    const names: string[] = String(pd[0][name] || '')
      .split(',')
      .reduce((acc, cur) => {
        const index = Number(cur)
        return [...acc, getName(name, index)]
      }, [] as string[])
    return names.join(' ')
  }

  showImage(pd: Array<PdState>, name: PdQualityPropertyNames) {
    if (name === 'swelling') {
      return false
    }

    if (pd.length > 1) {
      return false
    }

    return pd[0][`has${capitalize(name)}Image` as PdHasImagePropertyNames]
  }

  getQualitySettingText(
    name: QualitySettingNames,
    settings: PdSettingCollections
  ) {
    if (settings[name].length === 0) {
      return ''
    }

    if (settings[name].length > 1) {
      return '複数条件'
    }

    switch (name) {
      case 'isWasteFluid':
        return WasteFluidDict[(settings[name] as WasteFluidTypes[])[0]]

      case 'isExitsite':
        return ExitsiteDict[(settings[name] as ExitsiteTypes[])[0]]

      case 'isSwelling':
        return SwellingDict[(settings[name] as SwellingTypes[])[0]]

      default:
        throw new Error(`name of ${name} is not supported`)
    }
  }

  getItemClass(name: PdQualityPropertyNames, pd: Array<PdState>) {
    if (pd.length > 1) {
      return ''
    }

    if (!this.formattedPdSetting) {
      return
    }

    return (
      (['emg', 'warn'] as Array<keyof FormattedPdSetting>).find(type => {
        if (pd[0][name] == null) return false
        const targets = (this.formattedPdSetting as FormattedPdSetting)[type][
          `is${capitalize(name)}` as QualitySettingNames
        ]
        const values = String(pd[0][name] || '')
          .split(',')
          .map(v => Number(v))
        return values.some(v => targets.includes(v))
      }) || ''
    )
  }

  handleClickShowImage(pds: PdState[]) {
    this.$emit('showImage', pds[0].id, this.type)
  }
}
